import { Component, Output, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { UsedSgkc026aService } from '../../services/used-sgkc026a.service';
import { CodeConversionMstService } from '../../../../../../sg-base/sg-base-shared/services/codeConversionMst.service';
import { takeUntil } from 'rxjs/operators';
import { CodeConversionMstDto, Sgkc006aReqTankatableSearchinfoDto, Sgkc006aRequest, Sgkc021aReqReferencetableShutokuinfoDto, Sgkc021aRequest, Sgkc026aReqTankaApprvalauthShutokuinfoDto, Sgkc026aRequest, Sgkc026aResponse, TankatableLstInformationDto } from 'sg-api';
import { Subject } from 'rxjs';
import { UsedSgkc006aService } from '../../services/used-sgkc006a.service';
import { UsedSgkc021aService } from '../../services/used-sgkc021a.service';
import { SgAriaMessage } from '../../../../../../sg-base/sg-base-shared/models/sg-aria-message';
import { TankaauthorityDivcd } from '../../../../../sg-kc-shared/constants/tankaauthorityDivcd';
import { CompanyGroupCode } from '../../../../../sg-kc-shared/constants/companyGroupCode';

/**
 * 早見表出力画面
 * @exports
 * @class Sgkc041dComponent
 * @implements {OnInit, OnDestroy}
 */
@Component({
    selector: 'app-sgkc041d',
    templateUrl: './sgkc041d.component.html',
    styleUrl: './sgkc041d.component.scss'
})
export class Sgkc041dComponent implements OnInit, OnDestroy {

    /** 各必須項目の初期値 */
    readonly DEFAULT_SELECT_VALUE = " ";

    /** エラーメッセージリスト */
    @Output() errorMessageModelArray: Array<SgAriaMessage>;
    /** コード変換マスタのMap */
    @Output() codeConversionMstMap: Map<string, Array<CodeConversionMstDto>> = null;
    /** 単価表承認権限取得結果 */
    sgkc026aResponse: Sgkc026aResponse;
    /** 購読を停止するためのSubject */
    private onDestroy$ = new Subject();
    /** 単価表取得結果 */
    tankatable: TankatableLstInformationDto[];
    /** コード変換マスタ結果 */
    codeConversionMstResponse: Map<string, CodeConversionMstDto[]>;
    /** 検索条件に入力した対象年月 */
    searchTargetYm: string;
    /** 検索条件に入力したエネルギー種別 */
    energyClscode: string;
    /** 選択情報 */
    selectedTergetRowInfo: TankatableLstInformationDto[];
    /** 早見表出力対象検索条件格納フォーム */
    tankatableConditionForm: UntypedFormGroup;
    /** 早見表出力対象条件格納フォーム */
    referenceTableForm: UntypedFormGroup;
    /** 早見表出力対象検索結果表示フラグ */
    showResult: boolean = false;
    /** 早見表出力対象条件表示フラグ */
    showOutputCondition: boolean = false;

    /** コンストラクタ
     * @param {UntypedFormBuilder} fb - FormBuilder
     * @param {CodeConversionMstService} codeConversionMstServise - コード変換マスタサービス
     * @param {UsedSgkc026aService} usedSgkc026aService - 単価表承認権限取得サービス
     * @param {UsedSgkc006aService} usedSgkc006aService - 単価表取得サービス
     * @param {UsedSgkc021aService} usedSgkc021aService - 早見表出力サービス
     * @memberof Sgkc041dComponent
     */
    constructor(
        private fb: UntypedFormBuilder,
        private codeConversionMstServise: CodeConversionMstService,
        private usedSgkc026aService: UsedSgkc026aService,
        private usedSgkc006aService: UsedSgkc006aService,
        private usedSgkc021aService: UsedSgkc021aService,
    ) {
        this.tankatableConditionForm = this.fb.group({});
        this.referenceTableForm = this.fb.group({});
    }

    /** 
     * 初期処理
     * @memberof Sgkc041dComponent
     */
    ngOnInit(): void {
        // 受信データの購読設定
        this.usedSgkc026aService.tankatableAuthorityChanges
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(response => {
                this.sgkc026aResponse = response;
            });

        this.usedSgkc006aService.tankatableChanges
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(response => {
                this.tankatable = response;
            });

        // 単価表承認権限取得API
        // "read"[参照]（コードＩＤ：S10012、コード名称：単価権限区分コード）を設定しリクエストを作成
        const tankaApprvalauthShutokuinfo: Sgkc026aReqTankaApprvalauthShutokuinfoDto = {
            tankaauthorityDivcd: TankaauthorityDivcd.read
        }
        const sgkc026aRequest: Sgkc026aRequest = {
            tankaApprvalauthShutokuinfo: tankaApprvalauthShutokuinfo
        }
        // 単価表承認権限取得APIを呼び出し
        this.usedSgkc026aService.getTankatableAuthorityInf(sgkc026aRequest)
            .subscribe(response => {
            }, error => {
            });

        //コード変換マスタを呼び出し
        this.codeConversionMstServise.getCodeConversionMst([
            "S900020",// 会社コード
            "S100020",// エネルギー種別
            "S100110",// ＬＰ販売形態
            "S100180",// 早見表出力間隔
        ])
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(data => {
                this.codeConversionMstMap = data;
            });
    }

    /** 
   * 購読を停止する処理
   * @memberof Sgkc041dComponent
   */
    ngOnDestroy(): void {
        this.onDestroy$.next();
    }

    /** 
     * 検索ボタン押下処理
     * @memberof Sgkc041dComponent
     */
    onClickSearch(): void {
        this.selectedTergetRowInfo = [];
        this.showResult = false;
        let form = this.tankatableConditionForm.getRawValue().tankatableConditionInfo;
        // 対象年月を取得
        this.searchTargetYm = form.searchTargetYm;
        // 選択したエネルギー種別を取得
        this.energyClscode = form.energyClscode;
        // リクエストを作成
        const tankatableSearchinfo: Sgkc006aReqTankatableSearchinfoDto = {
            companygroupcode: CompanyGroupCode.saibukouri,// 会社グループコード
            companycode: form.companycode,// 会社コード
            energyClscode: form.energyClscode,// エネルギー種別コード
            apprvAuthorityCode: null,// 承認権限コード
            lpSalesformcode: form.lpSalesformcode === this.DEFAULT_SELECT_VALUE ? null : form.lpSalesformcode,// ＬＰ販売形態コード
            locationgroupSuppntDivisionnumber: form.locationgroupSuppntDivisionnumber === this.DEFAULT_SELECT_VALUE ? null : form.locationgroupSuppntDivisionnumber,// 地点群供給地点区分番号
            searchTargetYm: form.searchTargetYm.replace('-', ''),// 検索対象年月承認ステータスコード
            apprvStatuscode: null,// 承認ステータスコード
            referencetableOutputTargetflag: true // 早見表出力対象フラグ
        };
        const request: Sgkc006aRequest = {
            tankatableSearchinfo: tankatableSearchinfo
        };
        // サービス呼び出し
        this.usedSgkc006aService.searchTankatable(request)
            .subscribe(response => {
                if (response) {
                    this.showResult = true;
                }
            }, error => {
            });
    }

    /** 
    * クリアボタン押下時の処理
    * @memberof Sgkc041dComponent
    */
    onClickClear(): void {
        this.tankatableConditionForm.reset();
        this.showResult = false;
        this.selectedTergetRowInfo = [];
    }

    /** 
     * チェックボックス選択時の処理
     * @param {TankatableLstInformationDto[]} selectedList - 選択された行の情報リスト
     * @memberof Sgkc041dComponent
     */
    onSelected(selectedList: TankatableLstInformationDto[]): void {
        this.selectedTergetRowInfo = selectedList;
    }

    /** 
     * 出力ボタン押下処理
     * @remark 選択された行の情報を元に早見表出力を行う
     * @memberof Sgkc041dComponent
     */
    onClickOutput(): void {
        let form = this.referenceTableForm.getRawValue().referenceTableForm;
        if (this.selectedTergetRowInfo.length > 0) {
            this.selectedTergetRowInfo.map(dto => {
                // リクエストを作成
                const referencetableShutokuinfo: Sgkc021aReqReferencetableShutokuinfoDto = {
                    tankatableCode: dto.tankatableCode,
                    chargeCalcYm: form.chargeCalcYm,
                    empamtUpperlimit: !isNaN(Number(form.empamtUpperlimit)) && form.empamtUpperlimit.trim().length > 0 ? Number(form.empamtUpperlimit) : null,
                    referencetableOutputintervalCode: form.referencetableOutputintervalCode,
                }
                const request: Sgkc021aRequest = {
                    referencetableShutokuinfo: referencetableShutokuinfo
                }
                // サービス呼び出し
                this.usedSgkc021aService.outputReferenceTable(request)
                    .subscribe(response => {
                    }, error => {
                    });
            })
        }
    }
}